import s from './MetaData.module.css';

const MetaData = () => <div className={s.containerCabinet}>MetaData</div>
        
export default MetaData;
